/**
 * Wraps parentheses in a string with a given tag name.
 * @param input - The string to wrap parentheses in.
 * @param tagName - The tag name to wrap parentheses with. Defaults to "span".
 * @returns The string with parentheses wrapped in the given tag name.
 *
 * @example
 * wrapParens("Hello (world)", "em"); // "Hello <em>(world)</em>"
 */
export default function wrapParens(input: string, tagName = "span") {
	const openIdx = input.indexOf("(");
	const closeIdx = input.indexOf(")", openIdx);
	if (openIdx === -1 || closeIdx === -1) {
		return `${input}`;
	}
	const before = input.substring(0, openIdx).trim();
	const paren = input.substring(openIdx, closeIdx + 1).trim();
	const after = input.substring(closeIdx + 1).trim();

	let result = "";
	if (before) {
		result += `${before} `;
	}
	if (paren) {
		result += `<${tagName}>${paren}</${tagName}> `;
	}
	if (after) {
		result += `${after}`;
	}
	return result.trim();
}
